import {
  PAYMENT_SUBSCRIPTION_FETCH_SUCCESS,
  PAYMENT_SUBSCRIPTION_UPDATE_SUCCESS
} from '../constant/actionType';

const initialState = {
  isLoading: false,
  payments: [],
  success: false
};

const paymentSubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAYMENT_SUBSCRIPTION_FETCH_SUCCESS:
      return {
        ...state,
        isLoading: true,
        payments: action.data
      };
    case PAYMENT_SUBSCRIPTION_UPDATE_SUCCESS:
      return {
        ...state,
        success: action.data
      };

    default:
      return state;
  }
};

export default paymentSubscriptionReducer;
